const appConfig = {
  apiUrlBase: 'https://vmi.tst.mccolls.net.au/api',
};

export default appConfig;
